import React from 'react';

import { Nullable } from '@common/typescript/objects/Nullable';

interface DebounceContext<T> {
	timer: ReturnType<typeof setTimeout>;
	value: Nullable<T>;
}

export function useDebounce<T>(handler: (value: Nullable<T>) => void, period: number): (value: Nullable<T>) => void {
	const debounce = React.useRef<Nullable<DebounceContext<T>>>();

	const onTimeout = () => handler(debounce.current?.value ?? null);

	React.useEffect(() => {
		return () => clearTimeout(debounce.current?.timer);
	}, []);

	return (value: Nullable<T>) => {
		if (debounce.current) {
			clearTimeout(debounce.current.timer);
		}

		debounce.current = { timer: setTimeout(onTimeout, period), value };
	};
}
